const basicSort = (by, direction) => (a, b) => {
  if (a[by] > b[by]) {
    return direction === "DESC" ? -1 : 1
  } else if (a[by] < b[by]) {
    return direction === "DESC" ? 1 : -1
  } else {
    return 0
  }
}

export { basicSort }
